import { main } from './output/Gesso.Example.ReferenceFrames/index.js';main();